import { activityCustomTypesAccessLevels } from "PFCore/helpers/custom_types";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { AccessLevel, ActivityPureCustomValue, Profile } from "PFTypes";
import { useCallback } from "react";

type CustomFieldToSave = {
  type: { name: string };
  values: ActivityPureCustomValue[];
};

export const useGetCustomFieldsToSave = () => {
  const { data: currentProfile } = useCurrentProfile();
  const { getCustomTypeByName } = useCustomTypes();

  const getCustomFieldsToSave = useCallback(
    (customFields: CustomFieldToSave[], activityCreator: Profile | null): CustomFieldToSave[] =>
      customFields.filter(({ type }) => {
        const customType = getCustomTypeByName(type.name);

        if (!customType?.id) {
          return false;
        }

        return (
          activityCustomTypesAccessLevels(currentProfile, activityCreator)[customType.id] ===
          AccessLevel.ReadWrite
        );
      }),
    [currentProfile, getCustomTypeByName]
  );

  return { getCustomFieldsToSave };
};
